import React from 'react';
import Typography from 'material-ui/Typography';

const ResultEmptyPanel = () => {
  return (
    <Typography variant="subheading" style={{ marginTop: 20 }}>
      アイテムがありません。
    </Typography>
  );
}

ResultEmptyPanel.propTypes = {
};

export default ResultEmptyPanel;



// WEBPACK FOOTER //
// ./src/components/OrderDetail/panels/ResultEmptyPanel.jsx